import { AiMatchingRouteGate } from "../components/AiMatchingRouteGate";
import { LoginLegacy } from "./legacy/LoginLegacy";
import { LoginPreview } from "./LoginPreview";

export const Login = () => (
  <AiMatchingRouteGate preview={<LoginPreview />} legacy={<LoginLegacy />} />
);
